import { memo, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "./context";

const HomeChecklist = ({ listProps }) => {

    const {
        neonUser,
        getAgencyClients,
        clientAuthList,
        brandList,
        getBrands,
        marketplaceList,
        adsProfileIdsLoaded
    } = useContext(AppContext)
    const [agencyLoaded, setAgencyloaded] = useState(false)
    const [brandErrors, setBrandErrors] = useState([])
    const [filterList, setFilterList] = useState([])
    const [list, setList] = useState([
        {
            key: "seller_account",
            desc: "Authorize a Selling Account",
            link: "/brand"
        },
        {
            key: "market_plan",
            desc: "Authorize an Ads account",
            link: "/brand"
        },

        {
            key: "subscribe",
            desc: "Maintain an Active Subscription",
            link: "/account/subscription"
        },
        {
            key: "data_backfill",
            desc: "Data backfill will take between 24 - 48 hours after authentication",
            link: null,
        },
        {
            key: "download",
            desc: "Download the Chrome Extension and Login",
            link: `https://chromewebstore.google.com/detail/bispoke-sidekick/pkmoolhbekigfdbnfdljhoagcfhnlbgc?authuser=0&hl=en`,
        },
    ])

    const getChecklistColumns = () => {

        let list = Object.keys(listProps).filter(x => !["id", "user_id"].includes(x))
        // console.log({ list, listProps });
        setFilterList(list)
        return list;

    }


    useEffect(() => {
        if (!!neonUser.user_id) {
             getAgencyClients();
        }
    }, [neonUser])

    useEffect(() => {
        if(marketplaceList.length > 0 && !!neonUser.user_id) {
            (async () => {
                await   getAgencyClients()
                setAgencyloaded(true)
                return
            })()
            
        }
    }, [marketplaceList, neonUser])

    useEffect(() => {
        if(agencyLoaded) {
            (async () => {
                await getBrands()
                return
            })()
        }
    },[agencyLoaded, adsProfileIdsLoaded])

    useEffect(() => {
        if(brandList.length > 0) {
            setBrandErrors(brandList.filter( x => x['active?'] && x.has_error))
        }
    }, [brandList])

    useEffect(() => {
        // console.log("BRAND ERRORS", brandErrors)
    }, [brandErrors])

    useEffect(() => {
        // console.log("LIST", list)
    }, [list])

    useEffect(() => {
        // console.log("HOMECHECKLIST")
        getChecklistColumns()
    }, [])

    return (
        <div className={"d-flex flex-column "}>
            {brandErrors.length > 0 &&
                <span className="poppins">
                    <div className="d-flex gap-2 my-2">
                        <img src={"/src/tick-no.png"} style={{ width: 20, height: 20 }} />
                        <span className="fw-bold text-danger">{brandErrors.length} Account/Brand(s) have 1 or more accounts with authentication issues.</span>
                        <Link to="/brand" className='small-btn'>View</Link>
                    </div>

                </span>
            }
            {filterList.filter(x => (["owner", "admin"].includes(neonUser?.user?.role) || x == 'download')).map((x, i) => (
                <span key={i}>
                    {x == 'subscribe' && neonUser?.role == 'admin' ?
                        null
                        :
                        <div className="d-flex gap-2 my-2">
                            {listProps[x] ?

                                <img src={"/src/tick-yes.png"} style={{ width: 20, height: 20 }} />
                                :
                                x == "data_backfill" ?
                                    <img src={"/src/info.svg"} style={{ width: 20, height: 20 }} />
                                    :
                                    <img src={"/src/tick-no.png"} style={{ width: 20, height: 20 }} />
                            }
                            <span className="poppins">
                                {list.filter(xx => xx.key == x)[0].desc || false}&nbsp;
                                {list.filter(xx => xx.key == x)[0].link ?
                                    <>
                                        {!listProps[x] &&
                                            <Link to={list.filter(xx => xx.key == x)[0].link} className='small-btn'>View</Link>
                                        }
                                        {x == "download" && listProps[x] && <Link to={list.filter(xx => xx.key == x)[0].link} className='small-btn'>View</Link>}
                                    </>

                                    :
                                    null
                                }
                            </span>
                        </div>
                    }
                </span>

            ))

            }
        </div>

    )
}

export default HomeChecklist